<template lang="pug">
    div(v-if="reports.length > 0" style="border:0px solid;")
        div(class="" style="height:calc(100vh - 255px); overflow-y:scroll; overflow-x:hidden; border:0px solid;")
            template(v-for="(report, index) in reports")
                div(:key="index" class="mb-3" style="border-radius:6px; overflow:hidden; border:1px solid lightgrey;")
                    table(cellpadding="0" cellspacing="0" style="width:100%; border:0px solid;")
                        tr
                            td(style="width:250px; border:0px solid;")
                                div(class="pa-2" style="position:relative; height:230px; border:0px solid;")
                                    div(class="mb-1" style="font-size:16px; font-weight:500;") {{ report.period }}
                                    div(style="font-size:13px; height:18px;")
                                        table(cellpadding="0" cellspacing="0" style="width:100%; border:0px solid;")
                                            tr
                                                td(style="width:50px;") Date:
                                                td {{ report.date_report }}
                                    div(style="font-size:13px; height:18px;")
                                        table(cellpadding="0" cellspacing="0" style="width:100%; border:0px solid;")
                                            tr
                                                td(style="width:50px;") Sales:
                                                td(style="color:#6CB9AD;") {{ formatMillions(report, 'sales') }} ({{ compareChangesFromPreviousQuarter(report, 'sales') }})
                                    div(style="font-size:13px; height:18px;")
                                        table(cellpadding="0" cellspacing="0" style="width:100%; border:0px solid;")
                                            tr
                                                td(style="width:50px;") Profit:
                                                td(style="color:#6CB9AD;") {{ formatMillions(report, 'profit') }} ({{ compareChangesFromPreviousQuarter(report, 'profit') }})
                                    div(style="font-size:13px; height:18px;")
                                        table(cellpadding="0" cellspacing="0" style="width:100%; border:0px solid;")
                                            tr
                                                td(style="width:50px;") EPS:
                                                td(style="color:#6CB9AD;") {{ report.eps.toFixed(2) }} ({{ compareChangesFromPreviousQuarter(report, 'eps') }})
                                    div(style="position:absolute; bottom:3px; width:100%; border:0px solid;")
                                        img(@click="openPDF(report)" src="@/assets/pdf-icon.svg" style="cursor:pointer; border:0px solid;")
                                        span(v-for="media in report.media" @click="openMedia(media)" class="blue3 ml-2" style="cursor:pointer; border:0px solid;")
                                            v-icon(color="white" size="20" style="border:1px solid;") mdi-play-circle-outline
                                        
                            td(style="border:0px solid;")
                                div(class="pa-2" style="height:230px; border:0px solid;")
                                    div(class="mb-1" style="font-size:16px; font-weight:500; border:0px solid;")
                                        table(cellpadding="0" cellspacing="0" style="width:100%;")
                                            tr
                                                td(style="border:0px solid;") {{ $t('ceo_summary') }}
                                                td(class="text-right" style="border:0px solid;")
                                    div(style="height:180px; overflow-y:scroll; overflow-x:hidden; border:0px solid;")
                                        div(style="font-size:12px;") {{ `${report.ceo_summary !== undefined ? report.ceo_summary : ''}` }}

                //- TODO: Keep for the moment for reference, but will remove later on
                //- div( class="reports-row pl-3 pr-3 pt-1 pb-1" :key="index" style="display: flex; align-items: center; flex-wrap: nowrap;border-bottom:1px solid lightgrey" @click="openPDF(report)")
                    div(class="" style="width:125px")
                        div(class="" style="display: flex; justify-content: center; align-items: center;height:35px; width:35px; border-radius:5px; border:0px solid red")
                            v-icon(size="24" color="black") mdi-file-document
                        div()
                            div(v-for="media in report.media" @click="openMedia(media)" class="blue3 ml-2" style="-display:inline-block; height:35px; width:35px; -padding-left:2.5px; padding-top:2px; border-radius:5px; border:0px solid;")
                                v-icon(color="white" size="30") mdi-play-circle-outline
                    div(class="" style="font-weight:600; width:100px") {{ report.period }}
                    div(class="" style="") {{ report.date_report }}
                //- hr(class="pa-0 ml-0 mr-0 mt-0 mb-1" style="width:1050px; background-color:#ccc; height:1px; border:none;")

            div(v-if="!sheet" style="overflow:hidden; height:35px; position:absolute; bottom:0; left:145px;")
                div(style="white-space:nowrap; overflow-x:scroll; overflow-y:hidden; width:920px; height:65px; border:0px solid;")
                    div(v-for="(item, index) in filesToWatch" :key="item.index" :class="item.active ? 'blue2' : 'blue3'" class="white--text mr-2 pt-1" style="display:inline-block; height:35px; border-radius:8px 8px 0 0; border:0px solid;")
                        div(class="text-left pl-2" style="height:35px; padding-top:1px; border:0px solid;")
                            div(@click="openMediaFromBottom(item, index)" style="float:left; border:0px solid;")
                                v-icon(v-if="item.pdf_link !== undefined" size="23" style="float:left;") $pdfFile
                                v-icon(v-else color="white" size="26" style="float:left;") mdi-play-circle-outline
                                div(class="ml-2" style="float:left; font-weight:600; margin-top:4.5px; border:0px solid;") {{ item.ticker }}
                                div(class="ml-4" style="float:left; font-weight:600; margin-top:4.5px; border:0px solid;") {{ item.period }}
                            div(@click="removeFile(item, false)" class="ml-2 pr-1" style="float:left; border:0px solid;")
                                v-icon(class="white--text" size="27") mdi-close

        div(@click:outside="sheet = false" class="text-center" ref="bottomInvestorReportsDrawer")
            v-bottom-sheet(v-model="sheet" hide-overlay inset persistent no-click-animation)
                v-sheet(class="text-center" style="position:relative;")
                    div(@mousedown="openWindow = true" @mouseup="restoreCloseWindow()" style="position:absolute; top:-35px; border:0px solid;")
                        div(style="overflow:hidden; height:35px;")
                            div(class="text-left" style="white-space:nowrap; overflow-x:scroll; overflow-y:hidden; width:920px; height:65px; border:0px solid;")
                                div(style="height:35px; border:0px solid;")
                                    div(v-for="(item, index) in filesToWatch" :key="index" :id="`scrollToTab${index}`" :class="item.active ? 'blue2' : 'blue3'" class="white--text mr-2 pt-1" style="display:inline-block; height:35px; border-radius:8px 8px 0 0; border:0px solid;")
                                        div(class="text-left pl-2" style="height:35px; padding-top:1px; border:0px solid;")
                                            div(@click="changeActive(item)" style="float:left; border:0px solid;")
                                                v-icon(v-if="item.pdf_link !== undefined" size="23" style="float:left;") $pdfFile
                                                v-icon(v-else color="white" size="26" style="float:left; border:0px solid;") mdi-play-circle-outline
                                                div(class="ml-2" style="float:left; font-weight:600; margin-top:4.5px; border:0px solid;") {{ item.ticker }}
                                                div(class="ml-4" style="float:left; font-weight:600; margin-top:4.5px; border:0px solid;") {{ item.period }}
                                            div(@click="removeFile(item)" class="ml-2 pr-1" style="float:left; border:0px solid;")
                                                v-icon(class="white--text" size="27") mdi-close

                    div(style="height:calc(100vh - 275px); border:0px solid;")
                        iframe(v-if="sheet && mediaFile.media_link !== undefined" :src="`${mediaFile.media_link}#view=FitH`" width="100%" style="height:100%; border:0px solid;")
                        object(v-else-if="sheet && mediaFile.pdf_link !== undefined" :data="`https://documents.millistream.com/${mediaFile.pdf_link}#view=FitH`" width="100%" style="height:100%; border:0px solid;")
</template>

<script>
import VueFroala from "vue-froala-wysiwyg";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import ChartCalendarIR from "../../components/ChartCalendarIR.vue";
import CalendarScroll from "./../../components/CalendarScroll.vue";

export default {
    components: {
        VueFroala,
        ChartCalendarIR,
        CalendarScroll
    },
    props: {
        stock_id: Number,
        company_id: Number,
        flag: Number
    },
    data() {
        return {
            sheet: false,
            openWindow: true,
            checkReloadPDF: true,
            reports: [],
            years: ["2018", "2019", "2020", "2021"],  //TODO: change this to be year dynamic... before december
            quarters: ["Q1", "Q2" ,"Q3" ,"Q4", "FY"],
            activePeriod: null,
            activeGroupOnYear: null,
            medias: null,
            filesToWatch: [],
            active_pdf_link: null
        };
    },
    methods: {
        ...mapActions([
            'loadCompanyReports',
            'loadCompanyWebcasts'
        ]),
        formatMillions(report, key) {
            const value = Number(report[key]);

            let currency = report.currency !== null ? report.currency : 'SEK';
            let formatGrade = 1;

            // console.log('formatGrade', formatGrade);
            // console.log('value', value);

            if(value >= 1000000) {
                formatGrade = 1000000;
                currency = `M${currency}`;
            } else if(value >= 1000) {
                formatGrade = 1000;
                currency = `K${currency}`;
            }

            return (new Intl.NumberFormat('sv-SE').format((value/formatGrade).toFixed(0))) + ' ' + currency;
        },
        mergePdfsAndMedias() {
            this.reports = this.reports.map((r) => {
                const localMediasTemp = this.getWebcastsForCompany.filter((m) => m.period === r.period);

                r.media = [];

                localMediasTemp.map((m) => {
                    r.media.push(m);
                });

                return r;
            });
        },
        changeActive(item) {
            const localFilesToWatch = JSON.parse(JSON.stringify(this.filesToWatch));
            const localItem = JSON.parse(JSON.stringify(item));

            for(const file of localFilesToWatch) {
                file.active = false;

                if(file.link === localItem.link) {
                    file.active = true;
                }
            }

            this.filesToWatch = localFilesToWatch;
        },
        restoreCloseWindow() {
            this.openWindow = false;

            setTimeout(() => {
                this.openWindow = true;
            }, 100);
        },
        close(e) {
            if(this.openWindow) {
                const firstRowTitleMenuElement = document.getElementById('firstRowTitleMenu');
                const navigationDrawerElement = document.getElementById('navigationDrawer');

                // console.log(firstRowTitleMenuElement);
                // console.log(navigationDrawerElement);

                if(firstRowTitleMenuElement !== null && navigationDrawerElement !== null) {
                    if(!firstRowTitleMenuElement.contains(e.target) && !navigationDrawerElement.contains(e.target)) {
                        // console.log('outside');
                        this.sheet = false;
                    }
                } else if(firstRowTitleMenuElement !== null && navigationDrawerElement === null) {
                    if(!firstRowTitleMenuElement.contains(e.target)) {
                        // console.log('outside');
                        this.sheet = false;
                    }
                }
            }
        },
        openPDF(pdf) {
            const localPDF = pdf;

            localPDF.stock_id = this.stock.stock_id;
            localPDF.ticker = this.stock.ticker;
            localPDF.link = localPDF.pdf_link;
            localPDF.active = false;

            let tempFilesFromLocalStorage = JSON.parse(localStorage.getItem('filesToWatch')) !== null ? JSON.parse(localStorage.getItem('filesToWatch')) : [];

            for(const file of tempFilesFromLocalStorage) {
                file.active = false;
            }

            if(tempFilesFromLocalStorage !== null) {
                tempFilesFromLocalStorage.unshift(localPDF);
            } else {
                tempFilesFromLocalStorage = [localPDF];
            }

            tempFilesFromLocalStorage = _.uniqBy(tempFilesFromLocalStorage, 'link');

            for(const file of tempFilesFromLocalStorage) {
                if(file.link === localPDF.link) {
                    file.active = true;
                }
            }

            this.filesToWatch = tempFilesFromLocalStorage;

            localStorage.setItem('filesToWatch', JSON.stringify(tempFilesFromLocalStorage));

            // console.log(JSON.parse(JSON.stringify(this.stock)));
            // console.log(JSON.parse(JSON.stringify(this.filesToWatch)));

            this.sheet = true;
        },
        openMedia(media) {
            const localMedia = media;

            localMedia.stock_id = this.stock.stock_id;
            localMedia.ticker = this.stock.ticker;
            localMedia.link = localMedia.media_link;
            localMedia.active = false;

            let tempMediaFromLocalStorage = JSON.parse(localStorage.getItem('filesToWatch')) !== null ? JSON.parse(localStorage.getItem('filesToWatch')) : [];

            for(const file of tempMediaFromLocalStorage) {
                file.active = false;
            }

            if(tempMediaFromLocalStorage !== null) {
                tempMediaFromLocalStorage.unshift(localMedia);
            } else {
                tempMediaFromLocalStorage = [localMedia];
            }

            tempMediaFromLocalStorage = _.uniqBy(tempMediaFromLocalStorage, 'link');

            for(const file of tempMediaFromLocalStorage) {
                if(file.link === localMedia.link) {
                    file.active = true;
                }
            }

            this.filesToWatch = tempMediaFromLocalStorage;

            localStorage.setItem('filesToWatch', JSON.stringify(tempMediaFromLocalStorage));

            // console.log(JSON.parse(JSON.stringify(this.stock)));
            // console.log(JSON.parse(JSON.stringify(this.filesToWatch)));

            this.sheet = true;
        },
        openMediaFromBottom(item, index) {
            const localItem = item;

            let tempFileFromLocalStorage = JSON.parse(localStorage.getItem('filesToWatch')) !== null ? JSON.parse(localStorage.getItem('filesToWatch')) : [];

            for(const file of tempFileFromLocalStorage) {
                file.active = false;

                if(file.link === localItem.link) {
                    file.active = true;
                }
            }

            this.filesToWatch = tempFileFromLocalStorage;

            this.sheet = true;

            setTimeout(() => {
                const element = document.getElementById(`scrollToTab${index}`);

                element.scrollIntoView();
            }, 200);
        },
        removeFile(file, checkActive = true) {
            let tempFilesFromLocalStorage = JSON.parse(JSON.stringify(this.filesToWatch));
            let positionOfActive = 0;

            if(checkActive) {
                for(const [i, f] of tempFilesFromLocalStorage.entries()) {
                    if(f.active) {
                        positionOfActive = i;
                    }
                }
            }

            tempFilesFromLocalStorage = tempFilesFromLocalStorage.filter((o) => o.link !== file.link);

            localStorage.setItem('filesToWatch', JSON.stringify(tempFilesFromLocalStorage));

            if(checkActive) {
                const checkIfActiveIsRemoved = tempFilesFromLocalStorage.find((f) => f.active);

                if(checkIfActiveIsRemoved === undefined) {
                    if(tempFilesFromLocalStorage.length === 0) {
                        this.sheet = false;
                    } else if(positionOfActive > 0) {
                        tempFilesFromLocalStorage[positionOfActive - 1].active = true;
                    } else {
                        tempFilesFromLocalStorage[positionOfActive].active = true;
                    }
                }
            }

            this.filesToWatch = tempFilesFromLocalStorage;
        },
        compareChangesFromPreviousQuarter(report, key) {
            const period = report.period;
            const previousYear = Number(period.substring(0, 4)) - 1;

            // console.log(period);
            // console.log(previousYear);

            let quarter = '';

            if(period.length > 4) {
                quarter = period.substring(4, 7);
            }

            // console.log(quarter);

            const previousYearsQuarter = `${previousYear}${quarter}`;

            // console.log(previousYearsQuarter);

            if(this.reports.filter((r) => r.period === previousYearsQuarter).length > 0) {
                const previousReport = JSON.parse(JSON.stringify(this.reports.filter((r) => r.period === previousYearsQuarter)[0]));
                const valueNow = Number(report[key]);
                const valuePrevious = Number(previousReport[key]);

                // console.log(previousReport);
                // console.log(valueNow);
                // console.log(valuePrevious);

                let difference = 0;

                if((valueNow / valuePrevious) >= 1 && (valueNow / valuePrevious) < 2) {
                    if(valueNow < valuePrevious) {
                        difference = '-' + (((valueNow / valuePrevious) * 100) - 100).toFixed(1) + '%';
                    } else {
                        difference = '+' + (((valueNow / valuePrevious) * 100) - 100).toFixed(1) + '%';
                    }
                } else if((valueNow / valuePrevious) >= 2) {
                    if(valueNow < valuePrevious) {
                        difference = '-' + (((valueNow / valuePrevious) * 100)).toFixed(1) + '%';
                    } else {
                        difference = '+' + (((valueNow / valuePrevious) * 100)).toFixed(1) + '%';
                    }
                } else {
                    if(valueNow < valuePrevious) {
                        difference =  '-' + (((1 - (valueNow / valuePrevious)) * 100)).toFixed(1) + '%';
                    } else {
                        difference =  '+' + (((1 - (valueNow / valuePrevious)) * 100)).toFixed(1) + '%';
                    }
                }

                 return difference;
            } else {
                return '0';
            }
        }
    },
    computed: {
        ...mapGetters([
            'getAllStocks',
            'getCompanyReports',
            'getCompanyWebcasts'
        ]),
        mediaFile() {
            return this.filesToWatch.find((f) => f.active === true) !== undefined ? this.filesToWatch.find((f) => f.active === true) : [];
        },
        stock() {
            return this.getAllStocks.find((s) => s.stock_id === this.$route.params.stock_id);
        },
        getWebcastsForCompany() {
            return this.getCompanyWebcasts.filter((w) => w.company_id === this.company_id);
        }
    },
    async mounted() {
        await this.loadCompanyReports(this.company_id);
        await this.loadCompanyWebcasts();

        this.reports = this.getCompanyReports;

        this.mergePdfsAndMedias();

        // console.log('reports');
        // console.log('reports');
        // console.log('reports');
        // console.log('reports');
        console.log(JSON.parse(JSON.stringify(this.reports)));
        // console.log('formatMillions', this.formatMillions(this.reports[0], 'sales'));
        // console.log(this.compareChangesFromPreviousQuarter(this.reports[0], 'sales'));

        if(localStorage.getItem('filesToWatch') !== null) {
            const tempMediaFromLocalStorage = JSON.parse(localStorage.getItem('filesToWatch'));

            for(const file of tempMediaFromLocalStorage) {
                file.active = false;
            }

            this.filesToWatch = tempMediaFromLocalStorage;
        }

        window.addEventListener('mouseup', this.close);

        // console.log(JSON.parse(JSON.stringify(this.reports)));
        // console.log(JSON.parse(JSON.stringify(this.getWebcastsForCompany)));
    },
    beforeDestroy() {
        window.removeEventListener('mouseup', this.close);
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

>>> .set-pdf-file-color {
    fill: white;
}

>>> .set-pdf-file-active-container {
    width: 24px;
    height: 32px;
}

>>> .set-pdf-file-active-color {
    fill: white;
}

>>> .v-bottom-sheet--inset {
    position: absolute;
    max-width: 920px !important;
    left: 370px;
}

.reports-row {
    cursor: pointer;
}

.reports-row:hover {
    background-color: rgba(0,0,0,.05)
}

</style>
